import { MoveOutType } from '@shared/enums/move-out-type.enum';
import { IRadioButtonOption } from '@shared/interfaces/radio-button-option.interface';

export const MoveOutTypeListConst: IRadioButtonOption<MoveOutType>[] = [
  /**
   * new enum values
   */
  {
    value: MoveOutType.Evict,
    label: 'evict',
  },
  {
    value: MoveOutType.Notice_Rented,
    label: 'notice-rented',
  },

  {
    value: MoveOutType.Notice_Unrented,
    label: 'notice-unrented',
  },

  {
    value: MoveOutType.Vacant_Rented,
    label: 'vacant-rented',
  },

  {
    value: MoveOutType.Vacant_Unrented,
    label: 'vacant-unrented',
  },
];
